import React from "react";
import { COUNTRIES_DIAL_CODES, CountryDialCode } from "./countries_dial_codes";

import { composeIBAN, isValidIBAN } from "ibantools";


export const areEqualArrays = (a?: any[], b?: any[]) => {
    return JSON.stringify(a) === JSON.stringify(b);
};
export const civilValid = (civilID: string) => {
    // if (id.length != 12) return false;
    console.log(civilID);
    var coeff = [2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
        sum = 0;
    for (var i = 0; i < civilID.length - 1; i++) {
        // assuming number is a 12 character string
        sum += parseInt(civilID[i]) * coeff[i];
    }
    return (civilID?.length === 12) &&
        (11 - (sum % 11) === parseInt(civilID[civilID.length - 1]));
}

export const parseBirthFromCivilID = (civilID: string): { year: number, month: number, day: number } | null => {
    if (!civilID || !civilValid(civilID)) {
        return null;
    }

    const normalizedCivilID = civilID.trim();
    if (normalizedCivilID.length < 8) {
        return null;
    }

    const centuryCode = normalizedCivilID[0];
    const yy = parseInt(normalizedCivilID.slice(1, 3), 10);
    const mm = parseInt(normalizedCivilID.slice(3, 5), 10);
    const dd = parseInt(normalizedCivilID.slice(5, 7), 10);

    if (Number.isNaN(yy) || Number.isNaN(mm) || Number.isNaN(dd)) {
        return null;
    }

    let year: number;
    if (centuryCode === "2") {
        year = 1900 + yy;
    } else if (centuryCode === "3") {
        year = 2000 + yy;
    } else {
        return null;
    }

    return { year, month: mm, day: dd };
}

export const getCivilIDAge = (civilID: string, today: Date = new Date()): number | null => {
    const birth = parseBirthFromCivilID(civilID);
    if (!birth) {
        return null;
    }

    const birthDate = new Date(birth.year, birth.month - 1, birth.day);
    if (
        Number.isNaN(birthDate.getTime()) ||
        birthDate.getFullYear() !== birth.year ||
        birthDate.getMonth() !== birth.month - 1 ||
        birthDate.getDate() !== birth.day ||
        birthDate > today
    ) {
        return null;
    }

    let age = today.getFullYear() - birthDate.getFullYear();
    if (
        today.getMonth() < birthDate.getMonth() ||
        (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())
    ) {
        age--;
    }

    return age;
}


export const getKFHAccountNo = (iban: string): string | undefined => {
    if (iban && iban.indexOf("KFHO") !== -1) {
        return iban.substring(18, 30);
    }
    // return
}

/** KFH (KFHO) Kuwaiti IBAN that passes the check digits.  Functions twin: functions/src/ibanFromText.ts */
export const isValidKfhIban = (iban?: string | null): iban is string =>
    !!iban && /^KW\d{2}KFHO\d{22}$/.test(iban) && isValidIBAN(iban);

/** kfhtrade: a verified KFH IBAN with its matching account number is final.  Functions twin: functions/src/ibanFromText.ts */
export const hasVerifiedKfhIban = (service: { iban?: string | null; acct?: string | null; ibanVerified?: boolean }) =>
    service.ibanVerified === true && isValidKfhIban(service.iban) && service.acct === service.iban.slice(-12);

export const generateIBANFromKFHAccountNo = (accountNo: string) => {
    //bban is always 26 characters, so we need to add KFHO and pad the rest with 0 until we have 26 characters with the account number
    let bban = "KFHO" + accountNo.padStart(26 - 4, "0");
    return composeIBAN({ countryCode: "KW", bban: bban });
}


export function usePrintSecondsSinceLastMount(_identifier: string) {
    const [seconds, setSeconds] = React.useState(0);
    // console.debug(`${identifier}, seconds since last mount: ${seconds}`);

    React.useEffect(() => {
        const timer = setInterval(() => setSeconds(seconds + 1), 1000);
        return () => {
            //   console.debug(`${identifier}: #useEffect cleanup`);
            clearInterval(timer);
        };
    }, [seconds]);
}

export function createRenderingInfoPrinter(identifier: string) {
    let count = 0;
    return () => {
        count++;
        // console.debug(`${identifier}: rendering (total: #${count}`);
        usePrintSecondsSinceLastMount(identifier);
    };
}



export const getCountriesList = (): CountryDialCode[] => {
    return COUNTRIES_DIAL_CODES;
}
